import { render, staticRenderFns } from "./ProcessSelection.vue?vue&type=template&id=18df3d58&scoped=true&"
import script from "./ProcessSelection.vue?vue&type=script&lang=ts&"
export * from "./ProcessSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18df3d58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
